import React, { Component } from 'react';
import styled from 'styled-components';
import nl2br from 'react-nl2br';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import people from '../../../assets/people.png';

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  background-color: #fa5856;
  padding: 1rem;
  color: #fff;
  font-size: 2.5rem;
`;

const Description = styled.p`
  text-align: center;
  line-height: 1.7;
`;

const Image = styled.img`
  margin-top: 2rem;
  width: 100%;
  height: auto;
`;

class Oakhouse extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const { intl } = this.props;

    return (
      <Container className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Title>
              <FormattedMessage id="Oakhouse.Title" />
            </Title>
            <Description>
              {nl2br(intl.formatMessage({
                'id': 'Oakhouse.Description',
              }))}
            </Description>
            <Description>
              <a
                href="https://www.oakhouse.jp"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.oakhouse.jp
              </a>
            </Description>
            <Image
              src={people}
              alt="people"
            />
          </div>
        </div>
      </Container>
    );
  }
}

export default injectIntl(Oakhouse);
